import { FormBlock } from '@/widgets/ServiceFormTemplate';

import { Icon, LinkAsButton, Typography } from '@/shared/ui';

import { ROUTES } from '@/router/config';

export const ServiceResult: React.FC = () => {
  return (
    <>
      <div className="citizen-appeal-to-mvs-service__result">
        <FormBlock title="Результат">
          <div className="citizen-appeal-to-mvs-service__result-icon">
            <Icon name="process_success" color="blue" width={36} height={36} />
          </div>
          <div className="citizen-appeal-to-mvs-service__result-content">
            <Typography variant="H3">Ваше звернення відправлене</Typography>
            <Typography>Звернення розглядаються у строк, що не перевищує 30 календарних днів.</Typography>
            <Typography>
              Перебіг та результати розгляду ви можете відслідковувати в розділі “Мої звернення” в особистому кабінеті.
            </Typography>
          </div>
        </FormBlock>
      </div>
      <div className="citizen-appeal-to-mvs-service__result-button-container">
        <LinkAsButton to={ROUTES.USER.REQUESTS.ACTIVE_REQUESTS}>Мої звернення</LinkAsButton>
      </div>
    </>
  );
};
